module.exports = false;


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-polyfill/~/core-js/modules/$.library.js
 ** module id = 77
 ** module chunks = 0
 **/